import { environment } from './../../environments/environment';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export const BASE_PATH = 'https://api.africom.axonwireless.co.za';
// export const BASE_PATH = 'http://127.0.0.1:62006';
export abstract class AbstractHttpService {
    private readonly username = 'africom_ApiUser';
    private readonly password = 'Zx9Y7w3';

    private getBasicAuthHeaders(): HttpHeaders {
        const authString = `${this.username}:${this.password}`;
        const encodedAuth = btoa(authString); // Encodes to Base64

        return new HttpHeaders({
            'Authorization': `Basic ${encodedAuth}`
        });
    }

	constructor(private http: HttpClient, private context: string) { }

	protected get<T>(uri: string): Observable<T> {
		return this.http.get<T>(`${this.getPathPrefix()}${uri}`, { headers: this.getBasicAuthHeaders() });
	}
	protected getWithOptions(uri: string, options: any):  any {		
		return this.http.get(`${this.getPathPrefix()}${uri}`, options);
	}	

	protected getBase64<T>(uri: string): Observable<string> {
		return this.http.get(`${this.getPathPrefix()}${uri}`, { responseType: 'text' });
	}
	protected getBlob<T>(uri: string): Observable<Blob> {
		return this.http.get(`${this.getPathPrefix()}${uri}`, { responseType: 'blob' });
	}
	protected post<T>(uri: string, payload: any, parameters?: HttpParams): Observable<T> {
		if (parameters) {
			return this.http.post<T>(`${this.getPathPrefix()}${uri}`, payload, { params: parameters, headers: this.getBasicAuthHeaders() });
		}
		return this.http.post<T>(`${this.getPathPrefix()}${uri}`, payload, { headers: this.getBasicAuthHeaders() });
	}
	protected doUploadFile(uri: string, payload: FormData): Observable<HttpEvent<object>> {
		return this.http.post(`${this.getPathPrefix()}${uri}`, payload, { reportProgress: true, observe: 'events' });
	}
	protected doDownloadFile(uri: string): Observable<HttpEvent<Blob>> {
		return this.http.get(`${this.getPathPrefix()}${uri}`, { responseType: 'blob', reportProgress: true, observe: 'events' });
	}
	protected doDownloadFileSimple(uri: string): Observable<Blob> {
		return this.http.get(`${this.getPathPrefix()}${uri}`, { responseType: 'blob' });
	}
	protected delete(uri: string): Observable<any> {
		return this.http.delete(`${this.getPathPrefix()}${uri}`);
	}
	public getPathPrefix(): string {
		console.log('Paths: ', {
			contextPath: environment.contextPath,
			basePath: BASE_PATH,
			context: this.context
		})
		
		return environment.contextPath + BASE_PATH + this.context;
	}
}
